import React, { Component } from 'react';
import { Translate } from '$common';



export default class Dropdown extends Component {
  static type = 'dropdown';
  static optionable = true;
  static elementName = Translate.get('dropdown');
  static icon = 'sort';

  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/dropdown.js